import { render, staticRenderFns } from "./AddCategories.vue?vue&type=template&id=46c34bd6&"
import script from "./AddCategories.vue?vue&type=script&lang=js&"
export * from "./AddCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports